var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSystemClose16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_System_Close_16px",
    "data-name": "Icon/System/Close/16px",
    transform: "translate(-85.056 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill_1",
    "data-name": "Fill 1",
    transform: "translate(85.056 6)",
    fill: "#343741"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.678,0,4.02,3.643.363,0H.347L0,.346,3.665,4,0,7.646.355,8,4.02,4.35,7.685,8,8,7.687V7.606L6.768,6.379,4.375,4,8,.387V.306L7.693,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.347099781036377 0 L 0.3626775741577148 0 L 4.020089149475098 3.642822265625 L 7.693077564239502 0 L 8 0.3056554794311523 L 8 0.3866887092590332 L 4.37523365020752 3.995999813079834 L 8 7.605800151824951 L 8 7.686844348907471 L 7.685044288635254 8 L 4.020089149475098 4.350177764892578 L 0.3551445007324219 8 L 0 7.646322250366211 L 3.664955615997314 3.995999813079834 L 0 0.3461775779724121 L 0.347099781036377 0 Z",
    stroke: "none",
    fill: "#343741"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSystemClose16Px);
export default __webpack_public_path__ + "static/media/Icon-System-Close-16px.7f079be51fc1a5be8875d4ddab727721.svg";
export { ForwardRef as ReactComponent };